import script from "./subtabs.vue?vue&type=script&setup=true&lang=js"
export * from "./subtabs.vue?vue&type=script&setup=true&lang=js"

import "./subtabs.vue?vue&type=style&index=0&id=3fa05695&scoped=true&lang=postcss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fa05695"]])

export default __exports__